import type { InvitationRole } from "./types";

export type Platform = "ios" | "android" | "other";

export function detectPlatform(userAgent: string): Platform {
  if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
  if (/android/i.test(userAgent)) return "android";
  return "other";
}

// Builds the "Open Daruvix" href. Plain <a href> only — no hidden
// iframes, no "wait N ms then fall back to the store" timing hacks.
// Those patterns are exactly the undocumented iOS install-context
// recovery this was told not to depend on, and they're also just
// unreliable: if the app is installed and its Universal Link / App Link
// association covers appLinkBase's domain (or it's a registered custom
// scheme), the OS intercepts this href before it ever loads as a page.
// If it isn't installed, nothing bad happens — the browser either shows
// its own "open in app?" prompt or does nothing, and the visible "Get
// Daruvix" / manual-code fallbacks remain the guaranteed path either way.
export function buildAppLink(
  appLinkBase: string,
  invitationId: string,
  role: InvitationRole | null,
  fragmentSecret: string | null,
): string | null {
  if (!appLinkBase || !invitationId) return null;
  const base = appLinkBase.replace(/\/+$/, "");
  const query = role ? `?role=${encodeURIComponent(role)}` : "";
  const fragment = fragmentSecret ? `#secret=${encodeURIComponent(fragmentSecret)}` : "";
  return `${base}/${invitationId}${query}${fragment}`;
}

export function buildStoreLink(
  platform: Platform,
  appStoreUrl: string,
  playStoreUrl: string,
): string | null {
  if (platform === "ios") return appStoreUrl || null;
  if (platform === "android") return playStoreUrl || null;
  // Unknown platform (desktop, etc.): prefer whichever is configured.
  return appStoreUrl || playStoreUrl || null;
}
